import { AmountRangeFilter, DateRangeFilter, ListFilterOperator, SortDirection, TextFilterOperator } from "../../contract/ContractFilter.types";
import { RecurrenceFilterEnum } from "../../common/components/filterPopover/subMenues/RecurrenceFieldSubMenu";
import { TaskStateEnum } from "../AnnualWheel.types";
import { StatusTimelineConfig } from "./components/statusTimeline/StatusTimelineFieldConfig";

export const defaultActivitiesPageSize = 50;

export interface ActivitiesSearchRequest {
    displayFields: Array<string>;
    filter: ActivitiesFilterRequest;
    timelineConfig?: StatusTimelineConfig;
}

export interface ListFilter<T> {
    value: T[];
    filterOperator: ListFilterOperator;
}

export interface TextFilter {
    value: string;
    filterOperator: TextFilterOperator;
}

export interface ActivitiesFilterRequest {
    customId?: TextFilter;
    description?: TextFilter;
    activities?: ListFilter<string>;
    priorities?: ListFilter<string>;
    status?: ListFilter<string>;
    complianceAreas?: ListFilter<string>;
    responsibles?: ListFilter<string>;
    assignees?: ListFilter<string>;
    businessAreas?: ListFilter<string>;
    generalTypes?: ListFilter<string>;
    contracts?: ListFilter<string>;
    externalContractPartyIds?: ListFilter<string>;
    internalContractPartyIds?: ListFilter<string>;
    tags?: ListFilter<string>;
    groupCompanies?: ListFilter<string>;
    frameworks?: ListFilter<string>;
    startDateRange?: DateRangeFilter;
    endDateRange?: DateRangeFilter;
    documentationRequired?: boolean;
    approvalOptions?: ListFilter<string>;
    notificationPeriodInDays?: AmountRangeFilter;
    recurrence?: RecurrenceFilter;
    searchText?: string;
    sortByColumn?: string;
    sortDirection?: SortDirection;
    pageNumber?: number;
    pageSize?: number;
}

export interface ActivitiesSearchResultViewModel {
    activities: Array<ActivitySearchItem>;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    overdueTaskCount: number;
    plannedTaskCount: number;
    completedTaskCount: number;
    totalTaskCount: number;
}

export interface ActivitySearchItem {
    id: string;
    name: string;
    deleted: boolean;
    notPartOfCurrentPlan: boolean;
    month: number;
    onFrameworkControl: boolean;
    isObligation: boolean;
    isProcessingActivityValidation: boolean;
    responsibleId: string | null;
    fields: Array<ActivityFieldValue>;
    timeline?: Record<string, TaskStateEnum | null>;
}

export interface ActivityFieldValue {
    value: any;
    type: ActivityFieldType;
    fieldId: string;
}

export enum ActivityFieldType {
    Text = 0,
    Date = 1,
    Boolean = 2,
    Status = 3,
    Priority = 4,
    BusinessAreaList = 5,
    TagList = 6,
    ComplianceAreaList = 7,
    SubTaskList = 8,
    EntityList = 9,
    Contract = 10,
    RelationList = 11,
    Recurrence = 12,
    Approval = 13,
    GeneralType = 14,
    Html = 15,
    Int = 16,
    Evaluation = 17,
}

export interface RecurrenceFilter {
    from?: number;
    to?: number;
    recurrenceFilterEnum?: RecurrenceFilterEnum;
}

export interface ActivityExportHeader {
    header: string;
    fieldType: ActivityFieldType;
}
